import { useMemo } from 'react';
import {
  GenericThresholdOptions,
  MergeThresholdsOptions,
  mergeThresholds,
  StepOptions,
  SupportedDataType,
} from '@/core';
import { useDataQueryResult } from './DataQueriesProvider';

/**
 * Reads dynamic thresholds from query results (`metadata.thresholds`, including
 * steps emitted by the per-query threshold runtime wrapper) and merges them
 * into the panel-spec thresholds via {@link mergeThresholds}.
 */
export function useDataThresholds<T extends GenericThresholdOptions<StepOptions> | undefined>(
  panelThresholds: T,
  dataTypeFilter: SupportedDataType | SupportedDataType[],
  options: MergeThresholdsOptions = {}
): T {
  const { queryResults } = useDataQueryResult({ dataTypeFilter });
  const { panelMax } = options;

  return useMemo(() => {
    const dynamic = queryResults
      .map((r) => r.data?.metadata?.thresholds)
      .filter((t): t is GenericThresholdOptions<StepOptions> => Boolean(t));
    return mergeThresholds(panelThresholds, dynamic, { panelMax });
  }, [queryResults, panelThresholds, panelMax]);
}
